<script>
  import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

  export let data;
  export let klass = "";

    const redX = (Math.random() - 0.5) * 20 + 50;
    const redY = Math.random() * 20;
    const greenX = 70 + Math.random() * 20;
    const greenY = (Math.random() - 0.5) * 2 + Math.random() * 20 + 18;
    const orangeX = (Math.random() - 0.5) * 2 + Math.random() * 20 + 52;
    const orangeY = 80 + Math.random() * 20;
    const blueX = (Math.random() - 0.5) * 2 + Math.random() * 20 + 20;
    const blueY = 90 + Math.random() * 10;
    const pinkX = Math.random() * 20 + 10;
    const pinkY = (Math.random() - 0.5) * 2 + Math.random() * 20 + 18;

    const random10 = Math.random() * 10;
    const random20 = Math.random() * 20;
    const random30 = Math.random() * 30;
    const randomPositiveNegative = (Math.random() - 0.5) * 2;


</script>

<div class={klass} style="--randomPositiveNegative: {randomPositiveNegative}; --random10: {random10}; --random20: {random20}; --random30: {random30}; --redX: {redX}; --redY: {redY}; --greenX: {greenX}; --greenY: {greenY}; --orangeX: {orangeX}; --orangeY: {orangeY}; --blueX: {blueX}; --blueY: {blueY}; --pinkX: {pinkX}; --pinkY: {pinkY};">
  <h2 on:click={()=>{dispatch('clickPost',{id: data.id})}}>
    <span class="underline">{@html data.title}</span>
  </h2>
  <div class="clip-bg"></div>
  <!-- <p>{@html data.text.replace(/\n/g, '<br />')}</p> -->
</div>

<style type="text/scss">
div {
  display: flex;
  place-items: center;
  justify-content: center;
  z-index: 2;
  transform: translateZ(calc(var(--randomPositiveNegative) * 10px + 2px )) rotate3d(1,1,1,0deg);
  max-height: 10vh;
  overflow: visible;
  position: relative;
}
h2 {
  color: #FFF;
  padding: 0;
  cursor: pointer;
  background-clip: border-box;
  width: 100%;
  max-width: 20ex;
  &:hover .underline, &:focus .underline {
    background-size: 100% 100%;
  }
}
.underline {
  width: calc(100%);
  background-image: linear-gradient(transparent calc(100% - 4px), var(--primary-bright) 4px);
  background-repeat: no-repeat;
  background-size: 0% 100%;
  transition: background-size 600ms;
}
.clip-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: scale3d(0.6,1.2,1) translateX(-40%);
  z-index: -110;
  top: 0;
  left: 0;
  background: linear-gradient(160deg, transparent 20%, var(--primary-light) 90%);;
  clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--greenX) * 1%) calc(var(--greenY) * 1%), calc(var(--orangeX) * 1%) calc(var(--orangeY) * 1%), calc(var(--blueX) * 1%) calc(var(--blueY) * 1%), calc(var(--pinkX) * 1%) calc(var(--pinkY) * 1%));
}
</style>